import React from 'react';
import { Checkbox } from '@clearcover/atlas';
import { Table } from 'Shared/components';
import { AttributePills } from 'BlockList/components/AttributePill';
import { DescriptionCell } from './cells/DescriptionCell';
import type { BlockingRule } from 'BlockList/types/blockingRule';
import styles from './RulesTable.module.css';

const HEADERS = ['Name', 'Attribute', 'Description', 'Active'];

const COLUMN_WIDTHS = ['140px', '160px', 3, '80px'];

const COLUMN_CLASSNAMES = [
  '',
  '',
  styles.overflowVisibleCell,
  styles.centerColumn,
];

type RulesTableProps = {
  rows: BlockingRule[];
  loading?: boolean;
  onToggle: (rule: BlockingRule) => void;
  hasPagination?: boolean;
};

export const RulesTable: React.FC<RulesTableProps> = ({
  rows,
  loading,
  onToggle,
  hasPagination = false,
}) => {
  return (
    <Table
      headers={HEADERS}
      columnWidths={COLUMN_WIDTHS}
      columnClassNames={COLUMN_CLASSNAMES}
      name="rules-table"
      loading={loading}
      hasPagination={hasPagination}
      rows={rows.map((row) => {
        const isSoftDeleted = row.deletedAt !== null;
        const isInactive = !row.enabled || isSoftDeleted;
        const dim = (node: React.ReactNode): React.ReactNode =>
          isInactive ? (
            <span className={styles.dimmedContent}>{node}</span>
          ) : (
            node
          );

        return {
          key: row.id,
          data: [
            dim(row.name),
            dim(<AttributePills attributeTypes={row.attributeTypes} />),
            {
              component: (
                <DescriptionCell
                  description={row.description}
                  isInactive={isInactive}
                />
              ),
              allowOverflow: true,
            },
            <Checkbox
              key="active"
              label="Active"
              name={`rule-active-${row.id}`}
              value={row.enabled && !isSoftDeleted}
              toggle
              hideLabel
              disabled={isSoftDeleted}
              onChange={() => onToggle(row)}
            />,
          ],
        };
      })}
    />
  );
};
